<template>
  <el-row :gutter="20">
    <el-col :span="24">
      <div id="compeSearchCase">
        <div class="flex">
          <h4 class="title">百度推广行业成本数据</h4>
          <el-alert
            title="备注：以下成本数据仅供参考！客户自身成本受预算，消费，推广地域，行业流量等因素影响，成本波动范围不定"
            type="warning"
            show-icon
            :closable="false"
          >
          </el-alert>
        </div>
        <el-tabs v-model="activeName" @tab-click="TabClick">
          <!-- 非医疗 -->
          <el-tab-pane label="非医疗" name="first">
            <div class="select flex">
              <!-- 一级 -->
              <el-select
                v-model="FYL_First_Name"
                placeholder="请选择"
                size="small"
                @change="FeiYiLiaoSecond"
              >
                <el-option
                  v-for="item in FYL_First_Options"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>
              <!-- 二级 -->
              <el-select
                v-model="FYL_Second_Name"
                placeholder="请选择"
                size="small"
                @change="FeiYiLiaoThird"
              >
                <el-option
                  v-for="item in FYL_Second_Options"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>
              <!-- 三级 -->
              <el-select
                v-model="FYL_Third_Name"
                placeholder="请选择"
                size="small"
                @change="GetCostData"
              >
                <el-option
                  v-for="item in FYL_Third_Options"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>
              <el-alert
                title="成本取5月数据：有消费客户数≥30，取TOP5平均成本；有消费客户数＜30，取TOP1成本"
                type="info"
                :closable="false"
              >
              </el-alert>
            </div>
            <!-- <div class="data-bar">
              <el-row :gutter="10">
                <el-col :span="12"> <span>行业平均成本</span> </el-col>
                <el-col :span="12">
                  <span>{{ CostDataValue ? CostDataValue : "暂无数据" }}</span>
                </el-col>
              </el-row>
            </div> -->
            <div class="data-list " :class="regionClass">
              <div v-if="FeiYiLiaoDatList.length > 0">
                <el-row :gutter="10">
                  <el-col
                    :span="8"
                    v-for="(item, index) in FeiYiLiaoDatList"
                    :key="index"
                  >
                    <div class="grid-content">
                      <span> {{ item.value }} </span>
                      <span>{{ item.name }}</span>
                    </div>
                  </el-col>
                </el-row>
              </div>
              <div v-else>
                <el-row :gutter="10">
                  <el-col :span="24">
                    <el-empty description="暂无数据"></el-empty>
                  </el-col>
                </el-row>
              </div>
            </div>
          </el-tab-pane>
          <!-- 医疗行业 -->
          <el-tab-pane label="医疗行业" name="second">
            <div class="select">
              <el-select
                v-model="YL_First_Name"
                placeholder="请选择"
                size="small"
                @change="YiLiaoSecond"
              >
                <el-option
                  v-for="item in YL_First_Options"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>
              <el-select
                v-model="YL_Second_Name"
                placeholder="请选择"
                size="small"
                @change="GetDataYiLiao_List"
              >
                <el-option
                  v-for="item in YL_Second_Options"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>
              <el-select
                v-model="regionValue"
                placeholder="请选择"
                size="small"
                @change="regionChange"
              >
                <el-option
                  v-for="item in region"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <div class="data-list bd" >
              <div v-if="YiLiaoDatList.length > 0">
                <el-row :gutter="10">
                  <el-col
                    :span="6"
                    v-for="(item, index) in YiLiaoDatList"
                    :key="index"
                  >
                    <div class="grid-content">
                      <span> {{ item.value }} </span>
                      <span>{{ item.name }}</span>
                    </div>
                  </el-col>
                </el-row>
              </div>
              <div v-else>
                <el-row :gutter="10">
                  <el-col :span="24">
                    <el-empty description="暂无数据"></el-empty>
                  </el-col>
                </el-row>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-col>
  </el-row>
</template>
<script>
import { GetDataFeiYiLiao, GetDataYiLiao } from "../utils/request.js";
import { Loading } from "element-ui";
export default {
  name: "IndustryCostData",
  props: {},
  data() {
    return {
      activeName: "first",
      FYL_First_Name: "",
      FYL_First_Options: [],
      FYL_Second_Name: "",
      FYL_Second_Options: [],
      FYL_Third_Name: "",
      FYL_Third_Options: [],
      CostDataValue: "",
      options: [],
      YL_First_Name: "",
      YL_First_Options: [],
      YL_Second_Name: "",
      YL_Second_Options: [],
      YiLiaoDatList_total: [],
      YiLiaoDatList: [],
      FeiYiLiaoDatList: [],
      region: [
        {
          value: "ZhengZhou",
          label: "郑州",
        },
        {
          value: "DiShi",
          label: "地市",
        },
      ],
      regionValue: "",
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.FeiYiLiaoFirst();
    });
  },
  methods: {
    //非医疗JSON数据格式转换
    FYL_transformJson(inputObject) {
      const properties = ["行业平均浅层转化成本", "账户预算参考设置", "参考月均线索量"];
      // 使用map函数遍历属性列表，构建新格式的数组
      return properties.map((key) => ({
        name: key,
        // 处理null和数字类型，null时显示为'-'
         value: inputObject[key] === null ? "-" : Math.floor(Number(inputObject[key])),
      }));
    },
    // 医疗JSON数据格式转换
    YL_transformJson(data) {
      const transformedData = [];
      // 定义地区关键词数组，用于识别哪些键对应哪个地区
      const regionKeywords = ["郑州", "地市"];

      // 遍历地区关键词，构建目标格式的数据
      regionKeywords.forEach((region) => {
        // 选择与当前地区相关的键
        const keysForRegion = Object.keys(data[0]).filter((key) =>
          key.includes(region)
        );
        // 构建该地区的成本数据数组
        const regionData = keysForRegion.map((key) => ({
          name: key,
          value: data[0][key] === null ? "-" : Math.floor(Number(data[0][key]) ), // 处理null和数字类型
        }));

        // 将构建好的地区数据添加到结果数组中
        transformedData.push(regionData);
      });

      return transformedData;
    },
    TabClick(e) {
      console.log(e.label);
      if (e.label == "非医疗") {
        this.FeiYiLiaoFirst();
      } else {
        this.YiLiaoFirst();
      }
    },
    // 非医疗一级行业
    FeiYiLiaoFirst() {
      this.FYL_First_Name = "";
      this.FYL_First_Options = [];
      this.FYL_Second_Name = "";
      this.FYL_Second_Options = [];
      this.FYL_Third_Name = "";
      this.FYL_Third_Options = [];
      this.FeiYiLiaoDatList = [];
      let loadingInstance = Loading.service({
        //启动loading服务
        fullscreen: true,
      });
      let params = {
        data_title: "一级行业",
        father_name: "",
      };
      GetDataFeiYiLiao(params)
        .then((res) => {
          this.FYL_First_Options = JSON.parse(res.data);
          loadingInstance.close();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 非医疗二级行业
    FeiYiLiaoSecond() {
      this.FYL_Second_Name = "";
      this.FYL_Second_Options = [];
      this.FYL_Third_Name = "";
      this.FYL_Third_Options = [];
      this.FeiYiLiaoDatList = [];
      let loadingInstance = Loading.service({
        //启动loading服务
        fullscreen: true,
      });
      let params = {
        data_title: "二级行业",
        father_name: this.FYL_First_Name,
      };
      GetDataFeiYiLiao(params)
        .then((res) => {
          this.FYL_Second_Options = JSON.parse(res.data);
          loadingInstance.close();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 非医疗三级行业
    FeiYiLiaoThird() {
      this.FYL_Third_Name = "";
      this.FYL_Third_Options = [];
      this.FeiYiLiaoDatList = [];
      let loadingInstance = Loading.service({
        //启动loading服务
        fullscreen: true,
      });
      let params = {
        data_title: "业务点",
        father_name: this.FYL_Second_Name,
      };
      GetDataFeiYiLiao(params)
        .then((res) => {
          this.FYL_Third_Options = JSON.parse(res.data);
          loadingInstance.close();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 获取行业平均成本
    GetCostData() {
      let loadingInstance = Loading.service({
        //启动loading服务
        fullscreen: true,
      });
      let params = {
        data_title: "数据",
        father_name: this.FYL_Third_Name,
      };
      GetDataFeiYiLiao(params)
        .then((res) => {
          this.FeiYiLiaoDatList = this.FYL_transformJson(JSON.parse(res.data)[0]);
          loadingInstance.close();
          console.log(this.FeiYiLiaoDatList);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    regionChange(e) {
      this.regionValue = e;
      if (e == "ZhengZhou") {
        this.YiLiaoDatList = this.YiLiaoDatList_total[0];
      } else {
        this.YiLiaoDatList = this.YiLiaoDatList_total[1];
      }
    },
    // 医疗行业 一级分类
    YiLiaoFirst() {
      let loadingInstance = Loading.service({
        //启动loading服务
        fullscreen: true,
      });
      this.YL_First_Name = "";
      this.YL_First_Options = [];
      this.YL_Second_Name = "";
      this.YL_Second_Options = [];
      this.regionValue = "";
      this.YiLiaoDatList = [];
      let params = {
        data_title: "MEG账户一级行业_新",
        father_name: "",
      };
      GetDataYiLiao(params)
        .then((res) => {
          this.YL_First_Options = JSON.parse(res.data);
          loadingInstance.close();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    YiLiaoSecond() {
      this.YL_Second_Name = "";
      this.YL_Second_Options = [];
      this.regionValue = "";
      this.YiLiaoDatList = [];
      let loadingInstance = Loading.service({
        //启动loading服务
        fullscreen: true,
      });
      let params = {
        data_title: "MEG账户二级行业_新",
        father_name: this.YL_First_Name,
      };
      GetDataYiLiao(params)
        .then((res) => {
          this.YL_Second_Options = JSON.parse(res.data);
          loadingInstance.close();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    GetDataYiLiao_List() {
      this.regionValue = "";
      this.YiLiaoDatList = [];
      let loadingInstance = Loading.service({
        //启动loading服务
        fullscreen: true,
      });
      let params = {
        data_title: "数据",
        father_name: this.YL_Second_Name,
      };
      GetDataYiLiao(params)
        .then((res) => {
          console.log(JSON.parse(res.data));
          this.YiLiaoDatList_total = this.YL_transformJson(JSON.parse(res.data));
          if (this.regionValue == "ZhengZhou") {
            this.YiLiaoDatList == this.YiLiaoDatList_total[0];
          } else this.YiLiaoDatList == this.YiLiaoDatList_total[1];
          loadingInstance.close();
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  computed: {
    regionClass() {
      return this.regionValue === "ZhengZhou" ? "zz" : "bd";
    },
  },
};
</script>
<style lang="less" scoped>
@import "../assets/reset.less";
.flex {
  display: flex;
  align-items: center;
  gap: 20px;
}
.el-alert {
  flex: unset;
  width: auto;
  &.el-alert--warning.is-light {
    background-color: @Color16;
    color: @Color15;
  }
}
.title {
  position: relative;
  padding-left: 15px;

  &::before {
    position: absolute;
    content: "";
    height: 20px;
    width: 5px;
    top: 50%;
    margin-top: -10px;
    left: 0px;
  }
}
/deep/.el-tabs__active-bar {
  background-color: @Color15;
}
/deep/.el-tabs__item.is-active {
  color: @Color15;
  font-weight: 700;
}
/deep/.el-tabs__item:hover {
  color: @Color15;
}
.select {
  /deep/.el-input {
    width: 150px;
    margin-right: 10px;
  }
}
.border {
  border: 1px solid #e6e6e6;
  border-radius: 5px;
  padding: 10px;
  min-height: 145px;
}

h4.title {
  &::before {
    background-color: @Color6;
  }

  i {
    color: @Color8;
    font-size: 14px;
  }
}
.industry-select-wrap {
  display: flex;
  align-items: center;
  color: @Color10;
  font-size: 14px;

  .com-div-wrap {
    .el-select {
      margin-left: 5px;
    }
  }
}
.data-bar {
  padding: 20px 0;
  .el-row {
    .el-col {
      font-size: 16px;
      font-weight: 700;
      color: #fff;
      padding: 10px !important;
      text-align: center;
      transform: skewX(-14deg);
      span {
        display: block;
        transform: skewX(14deg);
      }
      &:nth-child(1) {
        background-color: #75b4ff;
        transform-origin: top left;
      }
      &:nth-child(2) {
        background-color: @Color6;
        transform-origin: bottom left;
      }
    }
  }
}
.data-list {
  padding: 20px 0;
  &.zz {
    .el-row {
      .el-col {
        .grid-content {
          border: 1px solid #e1e4ff;
          background: #f6f7ff;
          span {
            &:nth-child(1) {
              color: #4865ff;
            }
          }
        }
      }
    }
  }
  &.bd {
    .el-row {
      .el-col {
        .grid-content {
          border: 1px solid #ffe9d3;
          background: #fff7f4;
          span {
            &:nth-child(1) {
              color: #ff8b16;
            }
          }
        }
      }
    }
  }
  .el-row {
    .el-col {
      .grid-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 10px;
        border: 1px solid @Color1;
        padding: 15px;
        box-sizing: border-box;
        border-radius: 5px;

        span {
          font-size: 14px;
          color: @Color10;
          &:nth-child(1) {
            font-size: 32px;
            font-weight: 700;
          }
        }
      }
    }
  }
}
/deep/.el-empty {
  .el-empty__image {
    display: none;
  }
}
</style>